import React, { useState, useEffect, useRef } from "react";
import _ from 'lodash';
import {
	Button,
	InputAdornment,
	IconButton,
	Modal,
	Container,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	FormControl,
	Autocomplete,
	Stack,
	TextField,
	Typography,
	FormGroup,
	Box,
	Switch,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Attachment } from "@mui/icons-material";
import ClearIcon from "@mui/icons-material/Clear";
import PhotoIcon from "@mui/icons-material/Photo";
import ImageIcon from "@mui/icons-material/ImageOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { AddCircleOutline, RemoveCircleOutline, Search } from "@mui/icons-material";

import config from "../../../../hoa-config";
import CustomCheckbox from "../../../../Container/custom-checkbox";
import SourceIDVerificationCard from "../common/SourceIDVerificationCard";
import PDFsContainerComponent from "../../../pdf-container-component/hoa-pool-access-form-pdf-container";

const AddAmenityModal = ({
	open,
	onClose,
	view,
	state,
	setState,
	setAmenities,
	toBeEditedAvailableAmenity,
	setToBeEditedAvailableAmenity,
	document,
	toggleOpen,
	deleteOpen,
	availableAmenity,
	setAvailableAmenity,
	amenityOptions,
	setAmenityOptions,
	setSelectedLocationIndex,
	setDocumentName,
	setSelectedDocument,
	setToBeDelete,
	checkNewAmenitiesWarning,
	previousHoa,
}: any) => {
	const [checkError, setCheckError] = useState(false);
	const [expanded, setExpanded] = useState<number | false>(0);
	const fromHourVisibleRef = useRef<any>({});
	const toHourVisibleRef = useRef<any>({});
	const [loading, setLoading] = useState(false);
	const [availabilityClipboard, setAvailabilityClipboard] = useState<any>(null);

	const handleFromHourVisibleChange = (timeSlotId: string, visible: boolean) => {
		fromHourVisibleRef.current[timeSlotId] = visible;
	};
	const handleToHourVisibleChange = (timeSlotId: string, visible: boolean) => {
		toHourVisibleRef.current[timeSlotId] = visible;
	};

	const resetAllVisibility = () => {
		Object.keys(fromHourVisibleRef.current).forEach((key) => {
			delete fromHourVisibleRef.current[key];
		});
		Object.keys(toHourVisibleRef.current).forEach((key) => {
			delete toHourVisibleRef.current[key];
		});
	};

	const timeSelection = ["Dusk", "Dawn", "Sunset", "Sunrise", "Morning", "Mid-day", "Midnight", "Afternoon", "Evening", "Night", "Time", "Undefined"];

	const handleAccordionChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		setExpanded(isExpanded ? panel : false);
	};

	const isTimeFormat = (value: string) => {
		const timeRegex = /^\d{1,2}:\d{2}$/;

		return timeRegex.test(value);
	};

	const addTimeSlot = (index: any, locationIndex: any) => {
		const updatedLocations = [...availableAmenity.locations];
		const updatedAvailabilities = [...updatedLocations[locationIndex].availability];

		updatedAvailabilities[index] = {
			...updatedAvailabilities[index],
			times: [...updatedAvailabilities[index].times, { from: "", to: "" }],
		};

		updatedLocations[locationIndex] = {
			...updatedLocations[locationIndex],
			availability: updatedAvailabilities,
		};

		setAvailableAmenity({ ...availableAmenity, locations: updatedLocations });
	};

	const handleCloseTime = (dayIndex: any, locationIndex: any, event: any, timeSlotId: any) => {
		if (fromHourVisibleRef.current[timeSlotId]) {
			delete fromHourVisibleRef.current[timeSlotId];
		}
		if (toHourVisibleRef.current[timeSlotId]) {
			delete toHourVisibleRef.current[timeSlotId];
		}

		const updatedLocations = [...availableAmenity.locations];
		const updatedAvailabilities = [...updatedLocations[locationIndex].availability];

		updatedAvailabilities[dayIndex] = {
			...updatedAvailabilities[dayIndex],
			times: event.target.checked ? [{ from: "Closed", to: "Closed" }] : [{ from: "", to: "" }],
		};

		updatedLocations[locationIndex] = {
			...updatedLocations[locationIndex],
			availability: updatedAvailabilities,
		};

		setAvailableAmenity({ ...availableAmenity, locations: updatedLocations });
	};
	const removeTimeSlot = (dayIndex: any, timeIndex: any, locationIndex: any, timeSlotId: any) => {
		if (fromHourVisibleRef.current[timeSlotId]) {
			delete fromHourVisibleRef.current[timeSlotId];
		}
		if (toHourVisibleRef.current[timeSlotId]) {
			delete toHourVisibleRef.current[timeSlotId];
		}

		const updatedLocations = [...availableAmenity.locations];
		const updatedAvailabilities = [...updatedLocations[locationIndex].availability];
		const updatedTimes = [...updatedAvailabilities[dayIndex].times];

		updatedTimes.splice(timeIndex, 1);

		if (updatedTimes.length === 0) {
			updatedTimes.push({ from: "", to: "" });
		}

		updatedAvailabilities[dayIndex] = {
			...updatedAvailabilities[dayIndex],
			times: updatedTimes,
		};

		updatedLocations[locationIndex] = {
			...updatedLocations[locationIndex],
			availability: updatedAvailabilities,
		};
		setAvailableAmenity({ ...availableAmenity, locations: updatedLocations });

		const newFromHourVisibleRef: any = {};
		const newToHourVisibleRef: any = {};

		updatedAvailabilities[dayIndex].times.forEach((_: any, newIndex: any) => {
			const newTimeSlotId = `${locationIndex}-${dayIndex}-${newIndex}`;
			newFromHourVisibleRef[newTimeSlotId] = fromHourVisibleRef.current[newTimeSlotId] || false;
			newToHourVisibleRef[newTimeSlotId] = toHourVisibleRef.current[newTimeSlotId] || false;
		});

		fromHourVisibleRef.current = newFromHourVisibleRef;
		toHourVisibleRef.current = newToHourVisibleRef;
	};

	useEffect(() => {
		if (toBeEditedAvailableAmenity) {
			setAvailableAmenity(JSON.parse(JSON.stringify(toBeEditedAvailableAmenity)));
		}
	}, [toBeEditedAvailableAmenity]);

	useEffect(() => {
		const newOptions = amenityOptions.filter((option: any) => {
			return !state.newAvailableAmenities.some((item: any) => item.amenityType === option);
		});
		setAmenityOptions(newOptions);
	}, [state]);
	const removeLocation = (e: any, locationIndex: number) => {
		let tempState: any = { ...availableAmenity };
		let locations = tempState.locations.filter((location: any, index: any) => index !== locationIndex);
		setAvailableAmenity({ ...availableAmenity, locations });
	};
	const handleLocationsInputChange = (index: number, value: any, key: string) => {
		let locations = [...availableAmenity.locations];
		locations[index] = {
			...locations[index],
			[key]: value,
		};
		setAvailableAmenity({ ...availableAmenity, locations });
	};

	const handleChange = (value: any, key: string) => {
		if (key === "locations") {
			let locations: any = availableAmenity?.locations ? [...availableAmenity?.locations] : [];
			const locationInputProperties: any = {
				amenityName: "",
				address: "",
				googleCoordinates: "",
				amenityAccessName: { id: "", name: "" },
				availability: [
					{ day: "Monday", times: [{ from: "", to: "" }] },
					{ day: "Tuesday", times: [{ from: "", to: "" }] },
					{ day: "Wednesday", times: [{ from: "", to: "" }] },
					{ day: "Thursday", times: [{ from: "", to: "" }] },
					{ day: "Friday", times: [{ from: "", to: "" }] },
					{ day: "Saturday", times: [{ from: "", to: "" }] },
					{ day: "Sunday", times: [{ from: "", to: "" }] },
				],
				rulesAndRegulations: "",
				rulesAndRegulationDocuments: [],
				paymentMethod: [],
				amenityPhotos: [],
				additionalAmenitiesDocument: [],
			};

			if (locations && locations.length >= 0) {
				locations.push(locationInputProperties);
			} else {
				locations = [
					{
						...locationInputProperties,
					},
				];
			}
			setAvailableAmenity({ ...availableAmenity, [key]: locations });
		} else if (key === "amenityType") {
			let newOptions = [];
			if (value) {
				newOptions = amenityOptions.filter((option: any) => {
					return !value.includes(option);
				});
			} else {
				newOptions = [...amenityOptions, availableAmenity[key]];
			}
			setAmenityOptions(newOptions);
			setAvailableAmenity({ ...availableAmenity, [key]: value });
		} else {
			setAvailableAmenity({ ...availableAmenity, [key]: value });
		}
	};

	const onSaveClick = () => {
		setCheckError(true);
		if (!availableAmenity.amenityType) return;
		let tempState = JSON.parse(JSON.stringify(state));
		// let index = tempState.newAvailableAmenities.indexOf(toBeEditedAvailableAmenity);
		let index = tempState.newAvailableAmenities.findIndex((amenities: any) =>
			_.isEqual(amenities, toBeEditedAvailableAmenity)
		);

		if (index >= 0) {
			tempState.newAvailableAmenities[index] = availableAmenity;
		} else {
			tempState.newAvailableAmenities.push(availableAmenity);
		}
		checkNewAmenitiesWarning(tempState.newAvailableAmenities, tempState.accessInformation, tempState.amenityEvents);
		setState(tempState);
		setAmenities([...tempState.newAvailableAmenities]);
		resetAllVisibility();
		setAvailableAmenity({});
		setToBeEditedAvailableAmenity({});
		setCheckError(false);
		onClose();
	};

	const deleteClick = (document: string, file: any, locationIndex: number) => {
		setSelectedLocationIndex(locationIndex);
		setDocumentName(document);
		setSelectedDocument(file);
		toggleOpen(!deleteOpen);
	};
	const onDeleteClick = (photo: any, locationIndex: number) => {
		setSelectedLocationIndex(locationIndex);
		setToBeDelete(photo);
		toggleOpen(!deleteOpen);
	};
	const handleUploadClick = (id: string, index: number) => {
		const inputElement = document.getElementById(`${id}-${index}`);
		if (inputElement) {
			inputElement.click();
		}
	};
	const closeModal = () => {
		onClose();
		setCheckError(false);
		setExpanded(false);
		resetAllVisibility();
		setToBeEditedAvailableAmenity({});
	};

	const updateAvailability = (index: any, dayIndex: any, timeIndex: any, v: any, timeSlotId: any, handleFromHourVisibleChange: any, handleLocationsInputChange: any, key: any) => {
		const updatedAvailabilities = [...availableAmenity.locations[index].availability];

		if (v === "Time") {
			handleFromHourVisibleChange(timeSlotId, true);
			updatedAvailabilities[dayIndex] = {
				...updatedAvailabilities[dayIndex],
				times: updatedAvailabilities[dayIndex].times.map((time: any, tIndex: any) => {
					if (tIndex === timeIndex) {
						return {
							...time,
							[key]: "",
						};
					}
					return time;
				}),
			};
		} else {
			handleFromHourVisibleChange(timeSlotId, false);
			updatedAvailabilities[dayIndex] = {
				...updatedAvailabilities[dayIndex],
				times: updatedAvailabilities[dayIndex].times.map((time: any, tIndex: any) => {
					if (tIndex === timeIndex) {
						return {
							...time,
							[key]: v,
						};
					}
					return time;
				}),
			};
		}

		handleLocationsInputChange(index, updatedAvailabilities, "availability");
	};

	const deleteSourceDocument = (index: number, parentIndex: number, parentKey: string) => {
		const locations = [...availableAmenity.locations];

		// Filter out the specific item from the parentKey array
		const updatedDocuments = locations[parentIndex][parentKey].filter((_: any, docIndex: number) => docIndex !== index);

		// Update the specific location with the modified parentKey
		locations[parentIndex] = {
			...locations[parentIndex],
			[parentKey]: updatedDocuments,
		};

		// Update the state with the modified locations
		setAvailableAmenity({ ...availableAmenity, locations });
	};

	const handleSourceFile = (event: any, index: number, parentIndex: number, parentKey: string) => {
		const { name, value } = event.target;
		const locations = [...availableAmenity.locations];
		// Create a copy of the specific location's parentKey array
		const updatedDocuments = [...locations[parentIndex][parentKey]];

		if (name === "files" && value.length > 0) {
			updatedDocuments[index] = {
				...updatedDocuments[index],
				[name]: value,
				isVerified: true,
			};
		} else if (name === "files" && value.length == 0) {
			updatedDocuments[index] = {
				...updatedDocuments[index],
				[name]: value,
				isVerified: false,
			};
		} else {
			updatedDocuments[index] = {
				...updatedDocuments[index],
				[name]: value,
			};
		}

		// Update the specific location with the modified parentKey
		locations[parentIndex] = {
			...locations[parentIndex],
			[parentKey]: updatedDocuments,
		};

		// Update the state with the modified locations
		setAvailableAmenity({ ...availableAmenity, locations });
	};

	const copyToClipboard = (time: any) => {
		setAvailabilityClipboard(time);
	};

	const pasteToClipboard = (locationIndex: number, dayIndex: number, time: any) => {
		console.log(time);
		console.log(availableAmenity);

		const updatedLocations = [...availableAmenity.locations];
		const updatedAvailabilities = [...updatedLocations[locationIndex].availability];

		updatedAvailabilities[dayIndex] = {
			...updatedAvailabilities[dayIndex],
			times: availabilityClipboard.times,
		};

		updatedLocations[locationIndex] = {
			...updatedLocations[locationIndex],
			availability: updatedAvailabilities,
		};

		setAvailableAmenity({ ...availableAmenity, locations: updatedLocations });
	};

	return (
		<Modal open={open}>
			<Container className="modal-container-style-amenity" sx={{ width: "1052px !important" }} disableGutters>
				<div className="modal-wrapper-amenity">
					<Stack
						direction={"row"}
						position={"sticky"}
						zIndex={9999}
						top={0}
						sx={{ background: "#EFF4FC" }}
						justifyContent={"space-between"}
						alignItems={"center"}
						pl={"24px"}
						pr={"24px"}
						height={72}
						borderBottom={"1px solid #E8E8E8"}
					>
						<Box display={"flex"} alignItems={"center"}>
							<p
								style={{
									color: "#3E3E3E",
									fontSize: "20px",
									fontWeight: "500",
									fontFamily: "roboto",
								}}
							>
								{Object.keys(toBeEditedAvailableAmenity).length ? `Update Amenity` : `Add Amenity`}
							</p>
						</Box>
						<Box>
							<IconButton onClick={closeModal}>
								<CloseOutlinedIcon sx={{ color: "#2F2F2F" }} />
							</IconButton>
						</Box>
					</Stack>
					<Stack style={{ padding: "6px 24px 0 24px" }}>
						<div>
							<Autocomplete
								ListboxProps={{ style: { maxHeight: "200px" } }}
								style={{ width: "284px", height: "62px", boxSizing: "border-box" }}
								disablePortal
								defaultValue={toBeEditedAvailableAmenity?.amenityType || ""}
								options={availableAmenity?.amenityType ? [] : amenityOptions}
								onChange={(e, v) => {
									handleChange(v, "amenityType");
								}}
								disableClearable={Boolean(!availableAmenity?.amenityType)}
								renderInput={(params) => {
									return (
										<div
											style={{
												display: "flex",
												marginTop: "20px",
												justifyContent: "space-between",
											}}
										>
											<TextField
												{...params}
												variant="standard"
												label="Amenities Type"
												error={checkError && !availableAmenity.amenityType}
												InputProps={{
													...params.InputProps,
													style: {
														padding: "8px 0px",
														fontSize: "14px",
														color: "#383838",
														fontWeight: "400",
													},
													startAdornment: availableAmenity?.amenityType &&
														config.amenityIcons[availableAmenity.amenityType] && ( // Render start adornment if selectedAmenity is truthy
															<InputAdornment position="start">
																{React.createElement(config.amenityIcons[availableAmenity.amenityType as string], {
																	color: "primary",
																})}
															</InputAdornment>
														),
												}}
											/>
										</div>
									);
								}}
							/>
						</div>
						<Stack gap={"16px"} minHeight={"405px"}>
							<div style={{ fontSize: "18px", fontWeight: "500", marginTop: "56px" }}>Locations</div>
							{availableAmenity.locations &&
								availableAmenity.locations.map((location: any, index: number) => (
									<div key={index}>
										<Accordion sx={{ background: "#FAFAFA" }} disableGutters expanded={expanded === index} onChange={handleAccordionChange(index)}>
											<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
												<div
													style={{
														flexGrow: 1,
														display: "flex",
														alignItems: "center",
														justifyContent: "space-between",
														width: "100%",
													}}
												>
													<div
														style={{
															display: "flex",
															alignItems: "center",
														}}
													>
														<Typography>{`Address ${index + 1}`}</Typography>
													</div>
													<IconButton onClick={(e) => removeLocation(e, index)}>
														<DeleteIcon />
													</IconButton>
												</div>
											</AccordionSummary>
											<AccordionDetails
												style={{
													borderTop: "1px solid #E8E8E8",
													paddingTop: "24px",
												}}
											>
												{availableAmenity.amenityType && (
													<div style={{ paddingBottom: "6px" }}>
														{availableAmenity.amenityType} {index + 1}
													</div>
												)}
												<div
													style={{
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<TextField
														style={{ width: "100%" }}
														variant="standard"
														label="Amenity Name"
														name="amenityName"
														value={location.amenityName}
														onChange={(e) => {
															handleLocationsInputChange(index, e.target.value, "amenityName");
														}}
														InputLabelProps={{
															style: { fontSize: "14px" },
														}}
														error={checkError && !state.title}
														InputProps={{
															style: {
																padding: "6px 0px",
																fontSize: "14px",
																color: "#383838",
																fontWeight: "400",
																width: "256px",
															},
															disabled: !availableAmenity.amenityType,
														}}
													/>
												</div>
												<div
													style={{
														display: "flex",
														marginTop: "24px",
														justifyContent: "space-between",
													}}
												>
													<TextField
														style={{ width: "100%" }}
														variant="standard"
														label={"Address"}
														name="address"
														value={location.address}
														onChange={(e) => {
															handleLocationsInputChange(index, e.target.value, "address");
														}}
														InputLabelProps={{
															style: { fontSize: "14px" },
														}}
														error={checkError && !state.title}
														InputProps={{
															style: {
																padding: "6px 0px",
																fontSize: "14px",
																color: "#383838",
																fontWeight: "400",
															},
														}}
													/>
												</div>
												<div
													style={{
														display: "flex",
														marginTop: "24px",
														justifyContent: "space-between",
													}}
												>
													<TextField
														style={{ width: "100%" }}
														variant="standard"
														label="Google Coordinates"
														name="googleCoordinates"
														value={location.googleCoordinates}
														onChange={(e) => {
															handleLocationsInputChange(index, e.target.value, "googleCoordinates");
														}}
														InputLabelProps={{
															style: { fontSize: "14px" },
														}}
														error={checkError && !state.title}
														InputProps={{
															style: {
																padding: "6px 0px",
																fontSize: "14px",
																color: "#383838",
																fontWeight: "400",
															},
														}}
													/>
												</div>
												<div style={{ marginTop: "24px" }}>
													<Autocomplete
														ListboxProps={{
															style: { maxHeight: "200px" },
														}}
														style={{
															width: "222px",
															height: "62px",
															boxSizing: "border-box",
														}}
														disablePortal
														value={location.amenityAccessName}
														onChange={(option: any, value: any) =>
															handleLocationsInputChange(
																index,
																{
																	name: value?.name || "",
																	id: value?.id || "",
																},
																"amenityAccessName"
															)
														}
														isOptionEqualToValue={(option, value) => option?.id === value?.id}
														getOptionLabel={(option) => option.name}
														options={state?.accessInformation}
														disabled={!state?.accessInformation?.length}
														renderInput={(params: any) => (
															<TextField
																variant="standard"
																{...params}
																label="Amenity Access Name"
																InputLabelProps={{
																	style: { fontSize: "14px" },
																}}
																InputProps={{
																	...params.InputProps,
																	style: {
																		padding: "8px 0px",
																		fontSize: "14px",
																		color: "#383838",
																		fontWeight: "400",
																	},
																	endAdornment: <React.Fragment>{params.InputProps.endAdornment}</React.Fragment>,
																}}
															/>
														)}
													/>
												</div>
												<div style={{ marginTop: "56px" }}>
													<Typography
														style={{
															fontSize: "16px",
															fontWeight: "500",
															color: "#3E3E3E",
														}}
													>
														Availability
													</Typography>
													<div>
														{location.availability &&
															location.availability.map((time: any, dayIndex: any) => (
																<Stack
																	direction={"row"}
																	key={dayIndex}
																	m={"16px"}
																	bgcolor={"#F2F2F2"}
																	p={1}
																	border={"1px solid #E8E8E8"}
																	borderRadius={"4px"}
																	width={"fit-content"}
																>
																	<Stack
																		style={{
																			borderRight: "1px solid #E8E8E8",
																			width: "108px",
																			height: "63px",
																		}}
																	>
																		<Typography p={"10px"} pt={"26px"} fontSize={14} color={"#303030"} fontWeight={500}>
																			{time.day}
																		</Typography>
																	</Stack>
																	<Stack alignItems={"baseline"} paddingRight={"32px"}>
																		{time.times.map((timeSlot: any, timeIndex: any) => {
																			const timeSlotId = `${index}-${dayIndex}-${timeIndex}`;
																			return (
																				<Stack
																					pl={"56px"}
																					mt={timeIndex != 0 ? "16px" : "0px"}
																					direction={"row"}
																					gap={2}
																					key={timeIndex}
																					justifyContent={"flex-end"}
																					alignItems={"flex-start"}
																				>
																					<Stack gap={1} direction={"row"} alignItems={"flex-start"}>
																						<Typography pt={"26px"} fontSize={14} color={"#383838"} fontWeight={500}>
																							From
																						</Typography>
																						<Stack>
																							<Autocomplete
																								disableClearable
																								disablePortal
																								disabled={timeSlot.from === "Closed"}
																								id={`time-selection-${timeSlotId}`}
																								options={timeSelection}
																								popupIcon={null}
																								value={
																									fromHourVisibleRef.current[timeSlotId]
																										? "Time"
																										: !isTimeFormat(timeSlot.from)
																										? timeSlot.from
																										: "Time"
																								}
																								onChange={(e, v) => {
																									updateAvailability(
																										index,
																										dayIndex,
																										timeIndex,
																										v,
																										timeSlotId,
																										handleFromHourVisibleChange,
																										handleLocationsInputChange,
																										"from"
																									);
																								}}
																								sx={{
																									m: 1,
																									minWidth: 160,
																								}}
																								style={{
																									background: "#FAFAFA",
																								}}
																								renderInput={(params: any) => <TextField {...params} label="Select" />}
																							/>
																							{fromHourVisibleRef.current[timeSlotId] || isTimeFormat(timeSlot.from) ? (
																								<TextField
																									style={{
																										background: "#FAFAFA",
																										marginLeft: "8px",
																										width: "160px",
																									}}
																									type="time"
																									value={timeSlot.from}
																									onChange={(e) => {
																										const updatedAvailabilities = [...location.availability];
																										updatedAvailabilities[dayIndex].times[timeIndex].from = e.target.value;
																										handleLocationsInputChange(index, updatedAvailabilities, "availability");
																									}}
																									InputLabelProps={{
																										style: {
																											fontSize: "14px",
																											transform: "translateY(10px) translateX(12px)",
																										},
																									}}
																									InputProps={{
																										endAdornment: (
																											<InputAdornment position="end">
																												{state.fromHour ? (
																													<ClearIcon
																														style={{
																															cursor: "pointer",
																														}}
																														onClick={(e) => {
																															const updatedAvailabilities = [...location.availability];
																															updatedAvailabilities[dayIndex].times[timeIndex].from = "";
																															handleLocationsInputChange(index, updatedAvailabilities, "availability");
																														}}
																													/>
																												) : (
																													""
																												)}
																											</InputAdornment>
																										),
																									}}
																								/>
																							) : (
																								<></>
																							)}
																						</Stack>
																					</Stack>
																					<Stack gap={2} direction={"row"} alignItems={"flex-start"}>
																						<Typography pt={"26px"} fontSize={14} color={"#383838"} fontWeight={500}>
																							To
																						</Typography>
																						<Stack>
																							<Autocomplete
																								disableClearable
																								disablePortal
																								popupIcon={null}
																								disabled={timeSlot.to === "Closed"}
																								id={`time-selection-${timeSlotId}`}
																								options={timeSelection}
																								value={
																									toHourVisibleRef.current[timeSlotId] ? "Time" : !isTimeFormat(timeSlot.to) ? timeSlot.to : "Time"
																								}
																								onChange={(e, v) => {
																									updateAvailability(
																										index,
																										dayIndex,
																										timeIndex,
																										v,
																										timeSlotId,
																										handleToHourVisibleChange,
																										handleLocationsInputChange,
																										"to"
																									);
																								}}
																								sx={{
																									m: 1,
																									minWidth: 160,
																								}}
																								style={{
																									background: "#FAFAFA",
																								}}
																								renderInput={(params: any) => <TextField {...params} label="Select" />}
																							/>
																							{toHourVisibleRef.current[timeSlotId] || isTimeFormat(timeSlot.to) ? (
																								<TextField
																									style={{
																										background: "#FAFAFA",
																										marginLeft: "8px",
																										width: "160px",
																									}}
																									type="time"
																									value={timeSlot.to || ""}
																									onChange={(e) => {
																										const updatedAvailabilities = [...location.availability];
																										updatedAvailabilities[dayIndex].times[timeIndex].to = e.target.value;
																										handleLocationsInputChange(index, updatedAvailabilities, "availability");
																									}}
																									InputLabelProps={{
																										style: {
																											fontSize: "14px",
																											transform: "translateY(7px)",
																										},
																									}}
																									InputProps={{
																										endAdornment: (
																											<InputAdornment position="end">
																												{state.fromHour ? (
																													<ClearIcon
																														style={{
																															cursor: "pointer",
																														}}
																														onClick={(e) => {
																															const updatedAvailabilities = [...location.availability];
																															updatedAvailabilities[dayIndex].times[timeIndex].to = "";
																															handleLocationsInputChange(index, updatedAvailabilities, "availability");
																														}}
																													/>
																												) : (
																													""
																												)}
																											</InputAdornment>
																										),
																									}}
																								/>
																							) : (
																								<></>
																							)}
																						</Stack>
																					</Stack>
																					<div>
																						<Stack direction={"row"} gap={1} pt={"26px"}>
																							<Button
																								disabled={time.times[timeIndex].from === "Closed"}
																								sx={{
																									color: time.times[timeIndex].from === "Closed" ? "#B0B0B0" : "#787878",
																									minWidth: 0,
																									padding: 0,
																								}}
																								onClick={() => removeTimeSlot(dayIndex, timeIndex, index, timeSlotId)}
																							>
																								<RemoveCircleOutline />
																							</Button>
																							<Button
																								disabled={time.times[timeIndex].from === "Closed"}
																								sx={{
																									color: time.times[timeIndex].from === "Closed" ? "#B0B0B0" : "#787878",
																									minWidth: 0,
																									padding: 0,
																									visibility: timeIndex === time.times.length - 1 ? "visible" : "hidden !important",
																								}}
																								onClick={() => addTimeSlot(dayIndex, index)}
																							>
																								<AddCircleOutline />
																							</Button>
																						</Stack>
																					</div>
																					<Stack
																						flexDirection={"row"}
																						alignItems={"center"}
																						sx={{
																							display: timeIndex === 0 ? "visible" : "none !important",
																						}}
																						style={{
																							paddingLeft: "22px",
																							paddingRight: "10px",
																							borderLeft: "1px solid #E8E8E8",
																							width: "108px",
																							height: "63px",
																							marginTop: "6px",
																						}}
																					>
																						<Switch
																							defaultChecked={time.times[timeIndex].from === "Closed"}
																							onChange={(event) => handleCloseTime(dayIndex, index, event, timeSlotId)}
																							inputProps={{
																								"aria-label": "controlled",
																							}}
																						/>
																						<Typography>Closed</Typography>
																					</Stack>
																					<Stack
																						flexDirection={"column"}
																						alignItems={"center"}
																						sx={{
																							display: timeIndex === 0 ? "visible" : "none !important",
																						}}
																						style={{}}
																					>
																						<IconButton onClick={() => copyToClipboard(time)}>
																							<ContentCopyIcon
																								sx={{
																									color: "#2F2F2F",
																									width: "20px",
																								}}
																							/>
																						</IconButton>
																						{availabilityClipboard && (
																							<IconButton onClick={() => pasteToClipboard(index, dayIndex, time)}>
																								<ContentPasteIcon
																									sx={{
																										color: "#2F2F2F",
																										width: "20px",
																									}}
																								/>
																							</IconButton>
																						)}
																					</Stack>
																				</Stack>
																			);
																		})}
																	</Stack>
																</Stack>
															))}
													</div>
												</div>
												<div
													className="sub-title-text"
													style={{
														margin: "56px 0px 24px 0px",
														color: "#3E3E3E",
													}}
												>
													Rules & Regulations
												</div>
												<TextField
													style={{ width: "75%", marginBottom: "36px" }}
													variant="outlined"
													value={location.rulesAndRegulations}
													onChange={(e) => {
														handleLocationsInputChange(index, e.target.value, "rulesAndRegulations");
													}}
													label="Write here..."
													multiline
													InputLabelProps={{
														style: { fontSize: "14px", margin: "5px" },
													}}
													InputProps={{ style: { minHeight: "106px" } }}
												/>
												<div
													style={{
														color: "#5B5B5B",
														fontSize: "14px",
														lineHeight: "16px",
														marginBottom: "10px",
														fontWeight: "500",
													}}
												>
													Rules & Regulations Document
												</div>
												<div className="helperText">Please upload the regulations pdf if available</div>
												<Button
													startIcon={<Attachment color="primary" />}
													variant="outlined"
													onClick={() => {
														const newSourceDocument = {
															isVerified: false,
															sourceId: "",
															sourceIdType: "",
														};
														const rulesAndRegulationDocuments = [...location.rulesAndRegulationDocuments, newSourceDocument];
														handleLocationsInputChange(index, rulesAndRegulationDocuments, "rulesAndRegulationDocuments");
													}}
												>
													Attach Document
												</Button>
												<Stack>
													{location.rulesAndRegulationDocuments.map((item: any, idx: number) =>
														item.hasOwnProperty("isVerified") ? (
															<SourceIDVerificationCard
																key={idx}
																index={idx}
																item={item}
																loading={loading}
																setLoading={setLoading}
																handleSourceFile={handleSourceFile}
																handleDeleteCard={deleteSourceDocument}
																parentIndex={index}
																parentKey="rulesAndRegulationDocuments"
															/>
														) : null
													)}
												</Stack>
												{location.rulesAndRegulationDocuments?.length > 0 ? (
													<>
														{Array.from(location.rulesAndRegulationDocuments).map((file: any, fileIndex: number) => {
															if (file.url) {
																return (
																	<PDFsContainerComponent
																		path="hoa"
																		folder="rulesAndRegulationDocuments"
																		document={`rulesAndRegulationDocuments`}
																		deleteClick={(document: string, name: any) => {
																			deleteClick(document, name, index);
																		}}
																		view={view}
																		key={fileIndex}
																		file={file}
																	/>
																);
															}
														})}
													</>
												) : (
													""
												)}
												<div className="sub-title-text" style={{ marginTop: "56px", color: "#3E3E3E" }}>
													Payment Method
												</div>
												<FormControl style={{ paddingTop: "12px" }}>
													<FormGroup
														style={{
															display: "flex",
															gap: "1rem",
															flexDirection: "initial",
														}}
													>
														{config.hoaAmenityPaymentMethod.map((item: string, idx: number) => (
															<CustomCheckbox
																key={idx}
																location={location}
																label={item}
																value={item}
																index={index}
																handleLocationsInputChange={handleLocationsInputChange}
															/>
														))}
													</FormGroup>
												</FormControl>
												<div className="sub-title-text" style={{ marginTop: "56px" }}>
													Photos
												</div>
												<div
													style={{
														color: "#5B5B5B",
														fontSize: "12px",
														lineHeight: "16px",
														marginBottom: "10px",
													}}
													className="helperText"
												>
													Upload photos of the amenities if available
												</div>

												<Button
													startIcon={<PhotoIcon color="primary" />}
													variant="outlined"
													onClick={() => {
														handleUploadClick("amenityPhotos", index);
													}}
												>
													Upload Photos
													<input
														id={`amenityPhotos-${index}`}
														hidden
														type="file"
														multiple
														accept="image/*"
														onChange={(e) => {
															const amenityPhotos = [...location.amenityPhotos, ...Array.from(e.target.files)];
															handleLocationsInputChange(index, amenityPhotos, "amenityPhotos");
														}}
													/>
												</Button>
												{!toBeEditedAvailableAmenity && location?.amenityPhotos?.length > 0 ? (
													<>
														{Array.from(location.amenityPhotos).map((photo: any) => {
															return (
																<div
																	style={{
																		cursor: "pointer",
																	}}
																	className="ov-pdf-container"
																>
																	<Stack direction={"row"} alignItems={"center"}>
																		<ImageIcon
																			style={{
																				width: "20px",
																				height: "20px",
																			}}
																		/>
																		<span
																			style={{
																				marginLeft: "14px",
																			}}
																			className="text-3E3E3E-14px normal"
																		>
																			{photo.name}
																		</span>
																	</Stack>
																	<Stack direction={"row"} alignItems={"center"}>
																		<DeleteIcon
																			onClick={() => onDeleteClick(photo, index)}
																			style={{
																				width: "20px",
																				height: "20px",
																				color: "#3576E5",
																			}}
																		/>
																	</Stack>
																</div>
															);
														})}
													</>
												) : (
													""
												)}

												{toBeEditedAvailableAmenity && location?.amenityPhotos?.length > 0 ? (
													<>
														<p className="helperText" style={{ fontWeight: "bold" }}></p>
														{Array.from(location?.amenityPhotos).map((photo: any) => {
															return (
																<div
																	style={{
																		position: "relative",
																		display: "inline-block",
																	}}
																>
																	<DeleteIcon className="img-delete-icon" onClick={() => onDeleteClick(photo, index)} />
																	<img className="hoa-amenities-img" src={photo.url} />
																</div>
															);
														})}
													</>
												) : (
													""
												)}

												<div className="sub-title-text" style={{ marginTop: "56px" }}>
													Additional Documents
												</div>
												<p>
													<Button
														startIcon={<Attachment color="primary" />}
														variant="outlined"
														onClick={() => {
															const newSourceDocument = {
																isVerified: false,
																sourceId: "",
																sourceIdType: "",
															};
															const additionalAmenitiesDocument = [...location.additionalAmenitiesDocument, newSourceDocument];
															handleLocationsInputChange(index, additionalAmenitiesDocument, "additionalAmenitiesDocument");
														}}
													>
														Attach Document
													</Button>

													<Stack>
														{location.additionalAmenitiesDocument.map((item: any, idx: number) =>
															item.hasOwnProperty("isVerified") ? (
																<SourceIDVerificationCard
																	key={idx}
																	index={idx}
																	item={item}
																	loading={loading}
																	setLoading={setLoading}
																	handleSourceFile={handleSourceFile}
																	handleDeleteCard={deleteSourceDocument}
																	parentIndex={index}
																	parentKey="additionalAmenitiesDocument"
																/>
															) : null
														)}
													</Stack>
													{location.additionalAmenitiesDocument?.length > 0 ? (
														<>
															{Array.from(location.additionalAmenitiesDocument).map((file: any, fileIndex: number) => {
																if (file.url) {
																	return (
																		<PDFsContainerComponent
																			path="hoa"
																			folder="additionalAmenitiesDocument"
																			document={`additionalAmenitiesDocument`}
																			deleteClick={(document: string, name: any) => {
																				deleteClick(document, name, index);
																			}}
																			view={view}
																			key={fileIndex}
																			file={file}
																		/>
																	);
																}
															})}
														</>
													) : (
														""
													)}
												</p>
											</AccordionDetails>
										</Accordion>
									</div>
								))}

							<Button
								style={{
									borderColor: "#E8E8E8",
									color: "#3E3E3E",
									maxWidth: "142px",
								}}
								onClick={() => handleChange([], "locations")}
								startIcon={<AddIcon color="primary" />}
								variant="outlined"
							>
								Add Address
							</Button>
							<div></div>
						</Stack>
					</Stack>
					<Stack style={{ padding: "24px", border: "1px solid #E8E8E8" }} direction={"row"} spacing={1} justifyContent="flex-end">
						<>
							<Button onClick={closeModal} variant="outlined">
								Cancel
							</Button>
							<Button onClick={onSaveClick} variant="contained" style={{ color: "#fff", backgroundColor: "#3576E5" }}>
								Save
							</Button>
						</>
					</Stack>
				</div>
			</Container>
		</Modal>
	);
};

export default AddAmenityModal;
